import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ErrorModalComponent } from '../../shared/error-modal/error-modal.component';
import { SupportErrorContext } from '../../_models/support-error-context';

@Injectable({
  providedIn: 'root'
})
export class ErrorModalHelperService {

  private _errorModalShowing: boolean;

  public isValidationError: boolean = false;
  public isAuthFailedInfoError: boolean = false;

  constructor(
    public dialog: MatDialog,
    private router: Router
    ) { }

  public show(message: string, error: any, title: string = ""): void {
    if (!this._errorModalShowing) {
      this._errorModalShowing = true;
      this.isValidationError = error.isValidationError == null ? false : error.isValidationError;
      this.isAuthFailedInfoError = error.status == null ? false : error.status === 401;

      const dialogRef = this.dialog.open(ErrorModalComponent, {
        data: { 
          title: title,
          errorMessage: message,
          isValidationError: this.isValidationError,
          isAuthFailedInfoError: this.isAuthFailedInfoError
         },
        panelClass: this.isValidationError ? 'my-validation-error-dialog' : this.isAuthFailedInfoError ? 'my-info-error-dialog' : 'my-error-dialog',
        disableClose: true
      });
      dialogRef.afterClosed().subscribe((confirm: boolean) => {
        this._errorModalShowing = false;
        if (error.status === 401) {
          this.router.navigate(['/login']);
        } else if (error.bookingNotFound) {
          // A page whose booking could not be loaded has nothing to show: back to the user's home page (40973).
          this.router.navigate(['/']);
        }
      });
    }
  }

  /**
   * Opens the error modal enriched with support-ticket diagnostics captured by the
   * global HTTP error interceptor. Shares the re-entrancy guard with show().
   */
  public showSupport(context: SupportErrorContext): void {
    if (this._errorModalShowing) {
      return;
    }
    this._errorModalShowing = true;

    const dialogRef = this.dialog.open(ErrorModalComponent, {
      data: {
        title: 'An error has occurred',
        errorMessage: context.errorMessage,
        isValidationError: false,
        isAuthFailedInfoError: false,
        support: context
      },
      panelClass: 'my-error-dialog',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(() => {
      this._errorModalShowing = false;
    });
  }

}
